import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import { Viewer } from 'v-viewer/dist/v-viewer'
import Img from '~/types/api/Img'
import { EventSliderData, SlideOptions, Slider } from '~/types/Slider'
import 'viewerjs/dist/viewer.css'
import ImageElement from '~/components/element/ImageElement'

@Component({
  components: {
    Viewer
  }
})
export default class ProductCertificates extends Vue {
  @Prop({ required: true, type: Array })
  readonly items!: Img[]

  @Ref()
  readonly slider!: Slider

  get code (): string {
    return JSON.stringify(this.items)
  }

  optionsSlider: SlideOptions = {
    slidesToShow: 2,
    infinite: false,
    navButtons: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 630,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  }

  currentSlide: number = 0

  get count (): number {
    return this.items.length
  }

  mounted () {
    this.slider.$on('after-change', (e: EventSliderData) => (this.currentSlide = e.currentSlide))
  }

  beforeDestroy () {
    this.slider.$off('after-change')
  }

  next () {
    if (this.slider) {
      this.slider.goToNext()
    }
  }

  prev () {
    if (this.slider) {
      this.slider.goToPrev()
    }
  }

  @Watch('items')
  onProductsChanged () {
    this.$nextTick(() => {
      this.currentSlide = 0
      this.slider.$off('after-change')
      this.slider.$on('after-change', (e: EventSliderData) => (this.currentSlide = e.currentSlide))
    })
  }

  render () {
    return (
      <div class="product-page-certificates">
        <div class="product-page-certificates__header">
          Сертификаты
        </div>
        <div class="product-page-certificates__slider">
          <viewer {...{
            props: {
              images: this.items
            }
          }}>
            {({ images }: any) => (
              <agile ref='slider' key={this.code} options={this.optionsSlider}>
                {images.map((e: any) => (
                  <div key={JSON.stringify(e)} class="product-page-certificates__item">
                    <ImageElement {...{
                      props: {
                        img: e
                      }
                    }} />
                  </div>
                ))}
              </agile>
            )}
          </viewer>
        </div>
        <div class="product-page-certificates__dots">
          {[...Array(this.count)].map((_, i) => (
            <div {...{
              class: {
                'product-page-certificates__dots-item': true,
                'product-page-certificates__dots-item_selected': this.currentSlide === i
              },
              on: {
                click: () => this.slider.goTo(i)
              }
            }}></div>
          ))}
        </div>
      </div>
    )
  }
}
